import styled, { css } from 'styled-components';
import { fontCondensed, fontUi } from '../../../../../../theme/typography';

export const StyledCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const StyledCard = styled.button`
  -webkit-appearance: none;
  appearance: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: none;
  ${({ $muted }) =>
    $muted &&
    css`
      opacity: 0.72;
    `}
  ${({ $selected, theme }) =>
    $selected &&
    css`
      border-color: ${theme.headerAccent};
    `}
`;

export const StyledCardHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 10px 12px 8px;
  background: ${({ theme }) => theme.hover};
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
`;

export const StyledCardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`;

export const StyledCardIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

export const StyledCardName = styled.span`
  ${fontCondensed};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ theme }) => theme.text};
`;

export const StyledCardMeta = styled.span`
  ${fontUi};
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledStatusRow = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const StyledMediaRow = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0;
  > div {
    margin: 0 1px;
  }
`;

export const StyledStats = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 4px 6px;
  width: 100%;
  padding: 8px 10px 10px;
`;

export const StyledStat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
  gap: 1px;
  text-align: center;
`;

export const StyledStatValue = styled.span`
  ${fontUi};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ $color, theme }) => $color || theme.text};
`;

export const StyledStatLabel = styled.span`
  ${fontUi};
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  margin: 24px 0;
  text-align: center;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledCount = styled.p`
  ${fontUi};
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.textFaint};
`;
